<div class="about-jumbotron jumbotron">
  <div class="container">
    <div class="d-md-flex flex-items-center gutter-md-spacious">
      <div class="col-md-7 text-center text-md-start">
        <h1 class="display-4 text-white">
          <img src="/assets/cartolab.png" width="85" height="85" class="d-inline-block align-top" alt="">
          Cartolabe
        </h1>
        <p class="about-lead px-2">
          <span class="me-2">
            Cartolabe is a data visualization platform developed by
          </span>
          <a href="https://www.inria.fr/" class="pe-2">
            <img src="/assets/inr_logo_fr_rouge.png" width="116" height="50" class="d-inline-block align-top" alt="inria">
          </a>
          <a href="https://www.cnrs.fr/" class="p-2">
              <img src="/assets/cnrs.svg" width="50" height="50" class="d-inline-block align-top" alt="cnrs">
          </a>
          <a href="https://www.universite-paris-saclay.fr/" class="p-2">
            <img src="/assets/Logotype UPSaclay_RVB.png" height="50" class="d-inline-bloc align-top" alt="upsaclay">
          </a>
        </p>
      </div>

      <div class="mx-auto col-sm-8 col-md-5 mt-sm-5">
        <div class="card text-center contact-card">
          <div class="card-header position-relative">
            <h4>Contact us</h4>
          </div>
          <div class="card-body">
            <p class="lead text-secondary">
              We'd love to hear from you !
            </p>
            <p class="text-secondary">Whether you need some help, have some feedback, or just want to talk ...</p>
            <a class="btn btn-outline-primary email-btn" href="mailto:{{contact}}" role="button">
              Send us an email
              <i class="material-icons">mail_outline</i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container landscape text-start">
  <div class="p-5">
    <h1>Visualize the scientific landscape</h1>
    <p class="text-secondary">Cartolabe lets you explore a scientific landscape built from unsupervised machine learning algorithms.
      Search for authors, articles, research teams & labs or even scientific terms and see where they fit on the map.
      Look for the nearest entities of each kind to understand the underlying connections that shape a specific domain.</p>
    <p class="text-secondary"> For details about its design rationales and implementation techniques, see <a href="https://doi.org/10.1109/MCG.2020.3033401">Cartolabe: A Web-Based Scalable Visualization of Large Document Collections</a>, also available on <a href="https://arxiv.org/abs/2003.00975">arXiv</a> and <a href="https://hal.archives-ouvertes.fr/hal-02499006">HAL</a>.</p>
  </div>
</div>

<div class="container sources text-start">
  <div class="p-5">
    <h1>Source Code Repositories</h1>
    <p class="text-secondary">The Cartolabe project is licensed under the Open Source and Free Software <a href="https://choosealicense.com/licenses/bsd-3-clause/">BSD 3-clause "New" or "Revised" License</a>. Sources are split into two repositories: <a href="https://gitlab.inria.fr/cartolabe/cartolabe-visu">Cartolabe-vis</a> for the web-based service and <a href="https://gitlab.inria.fr/cartolabe/cartolabe-data">Cartolabe-data</a> for the document processing pipelines. </p>
  </div>
</div>

<div class="container data">
  <div class="p-5">
    <h1 class="text-center">Datasets</h1>
    <div class="container-fluid" id="datasetsAboutContainer">
      <div class="row">
        <div class="col-sm-4 datasets-list">
          <mat-action-list>
            <button [class.active]="selectedDataset === dataset" mat-list-item (click)="selectDataset(dataset)" *ngFor="let dataset of datasets$ | async"> {{dataset.label}} </button>
          </mat-action-list>
        </div>
        <div class="col-sm-8" *ngIf="selectedDataset">
          <p class="text-secondary dataset-descriptions" [innerHtml]="selectedDataset?.about_description">
          </p>
	  <p class="text-secodary">Dataset version: {{selectedDataset?.version}}</p>
	  <p class="text-secondary"><a href="{{selectedDataset?.url}}" target="_blank">Download</a></p>
          <div class="dataset-stats" *ngIf="total > 0">
            <p class="text-secondary">
              This dataset includes <span class="stat-total fw-bold">{{total}}</span> entities :
            </p>
            <ul class="list-unstyled stats text-secondary">
              <li class="stat-item py-1" *ngFor="let nature of selectedDataset?.natures">
                <i [style.color]="nature.color" class="material-icons stat-icon pe-1">{{nature.icon}}</i>
                {{stats[nature.key]}} {{nature.label}}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container team text-center">
  <div class="p-5">
    <h1>Teamwork</h1>
    <p class="text-secondary">
      Cartolabe was built with help from these fine people.
    </p>

    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Philippe Caillou</h5>
            <p class="card-subtitle text-secondary">Associate Professor in Computer Science</p>
            <p class="card-text">Inria - TAU team</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Jean-Daniel Fekete</h5>
            <p class="card-subtitle text-secondary">Senior Research Scientist</p>
            <p class="card-text">Inria - AVIZ Team Leader</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Anne-Catherine Letournel</h5>
            <p class="card-subtitle text-secondary">Dev Team Leader</p>
            <p class="card-text">CNRS - LISN</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Felix Louistisserand</h5>
            <p class="card-subtitle text-secondary">Research Developper</p>
            <p class="card-text">Inria - TAU team</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Jonas Renault</h5>
            <p class="card-subtitle text-secondary">Research Engineer</p>
            <p class="card-text">CNRS - LISN</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Michele Sebag</h5>
            <p class="card-subtitle text-secondary">Principal Senior Research Fellow</p>
            <p class="card-text">Inria - TAU Team Leader</p>
          </div>
        </div>
      </div>

      <div class="col-lg-3 col-md-4 col-sm-6 mb-4">
        <div class="card contact-card">
          <div class="card-body">
            <h5 class="card-title">Hande Gözükan</h5>
            <p class="card-subtitle text-secondary">Research Engineer</p>
            <p class="card-text">Inria - SED</p>
          </div>
        </div>
      </div>

    </div>



  </div>
</div>
